import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Loader from "../../../../components/common/Loader";
import SnackbarToast from "../../../../components/common/SnackBar";
import InspectionArrow from "../../../../assets/images/inspection-arrow.svg";
import {
  Button,
  Col,
  Form,
  Row,
  Stack,
  Container,
  Card,
  Spinner,
} from "react-bootstrap";
import { MachineDetails } from "./machineDetails";
import ImageTag from "components/common/ImageTag";
export const StepForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [insptectionType, setInspectionType] = useState([]);
  const [modelid, setModelId] = useState([]);
  const [inspectionData, setInspectionData] = useState([]);
  const [inspectionMachine, setInspectionMachine] = useState({});
  //const [loading, setLoading] = useState(true);
  const [showSnackBar, setshowSnackBar] = useState({
    show: false,
    message: "",
    severity: "",
  });
  const state = location.state;
  useEffect(() => {
    
    setInspectionType(state.inspectionType);
    setModelId(state.model_id);
    setInspectionData(state.inspectionData);
    setInspectionMachine(state.inspectionMachine);
  }, []);
  const handleClose = () => {
    setshowSnackBar({
      show: false,
      message: "",
      severity: "",
    });
  };

  return (
    <>
      <section className="profile-main pt-4 inspector-bg">
        <Container className="">
          <Row>
            <Col md={12} lg={12}>
              <h1 className="fs-16  mb-3 mt-2">
                <ImageTag
                  src={InspectionArrow}
                  className="inspection-arrow"
                  onClick={() => {
                    navigate(-1);
                  }}
                />
                <span className="fw-bold">Inspection for:</span>{" "}
                {inspectionData?.sr_number} Model no.:
                <span className="fw-bold">
                  {" "}
                  {inspectionMachine?.model_number}
                </span>
              </h1>
            </Col>
          </Row>
        </Container>
        {/* Content */}

        {inspectionMachine.id && (
          <MachineDetails
            machine_id={inspectionMachine?.id}
            insptectionType={insptectionType}
            inspectionDate={inspectionData?.inspection_date}
            inspectionTime={inspectionData?.job_time}
            inspection_id={inspectionData.id}
          />
        )}
        {}

        <SnackbarToast showSnackBar={showSnackBar} handleClose={handleClose} />
        {/* <Loader isLoading={loading} /> */}
      </section>
    </>
  );
};
